<form class="row rounded-card" id="settings-integrations" [formGroup]="integrationsForm" (ngSubmit)="submitForm()">
  <div class="flex flex-wrap justify-between items-end mb-4">
    <div class="flex flex-col">
      <h2 data-testid="system-settings-integrations-title">{{ 'SYSTEM_SETTINGS.INTEGRATIONS.TITLE' | translate }}</h2>
      <span data-testid="system-settings-integrations-subtitle" class="text-base">
        {{ 'SYSTEM_SETTINGS.INTEGRATIONS.SUBTITLE' | translate }}
      </span>
    </div>
    <div class="flex items-center gap-2"></div>
  </div>

  <hr class="mb-1 mt-2 border-t">

  <section class="col-12 mt-4">
    <div class="rounded-card overflow-visible dc-settings-card" formGroupName="graceInsurance">
      <div class="flex items-center justify-between gap-3 mb-3">
        <h3>{{ 'SYSTEM_SETTINGS.INTEGRATIONS.GRACE_INSURANCE' | translate }}</h3>

        <p-toggleswitch
          inputId="grace-integration-active"
          class="mt-3"
          [(ngModel)]="graceInsuranceIsActive"
          [ngModelOptions]="{ standalone: true }"
          [ngClass]="{'disabled': isLoadingIntegrationSettings || !hasGraceInsuranceSettings}"
          [disabled]="isLoadingIntegrationSettings || !hasGraceInsuranceSettings"
          (onChange)="onGraceInsuranceStateChange($event)">
        </p-toggleswitch>
      </div>

      <app-notice class="block mt-3 mb-3" type="blue" dataTestId="grace-secret-configuration-notice" [message]="'SYSTEM_SETTINGS.INTEGRATIONS.SECRET_CONFIGURATION_NOTICE' | translate"></app-notice>

      <div class="field-wr mb-0">
        <label for="grace-api-url">
          {{ 'SYSTEM_SETTINGS.INTEGRATIONS.API_URL' | translate }}
        </label>
        <input id="grace-api-url" type="text" formControlName="apiUrl" autocomplete="off">
      </div>

      <div class="field-wr mb-0">
        <label for="grace-api-secretName">
          {{ 'SYSTEM_SETTINGS.INTEGRATIONS.SECRET_NAME' | translate }}
        </label>
        <input id="grace-api-secretName" type="text" formControlName="secretName">
      </div>

      <div class="field-wr mb-0">
        <label for="grace-cta-url">
          {{ 'SYSTEM_SETTINGS.INTEGRATIONS.CTA_URL' | translate }}
        </label>
        <input id="grace-cta-url" type="text" formControlName="ctaUrl" autocomplete="off">
      </div>

      <div class="row">
        <div class="field-wr mb-0 flex flex-col col-12 col-md-6">
          <label for="grace-maximum-item-value">
            {{ 'SYSTEM_SETTINGS.INTEGRATIONS.MAXIMUM_ITEM_VALUE' | translate }}
          </label>
          <input id="grace-maximum-item-value" type="text" formControlName="maximumItemValue" autocomplete="off">
        </div>

        <div class="field-wr mb-0 flex flex-col col-12 col-md-6">
          <label for="grace-maximum-age-of-protection">
            {{ 'SYSTEM_SETTINGS.INTEGRATIONS.MAXIMUM_AGE_OF_PROTECTION' | translate }}
          </label>
          <input id="grace-maximum-age-of-protection" type="number" formControlName="maximumAgeOfProtection"
            autocomplete="off">
        </div>
      </div>
    </div>
  </section>

  <div class="col-12 mt-6 mb-4 pt-8 border-t">
    <div class="flex items-center justify-end gap-3">
      <button type="submit" data-testid="update-integrations-settings-btn" class="btn primary-btn">
        {{ 'SYSTEM_SETTINGS.INTEGRATIONS.SAVE_CHANGES' | translate }}
      </button>
    </div>
  </div>
</form>

<!-- Confirmation: integration state change -->
<p-confirmDialog key="confirm-integration-state-change-dialog">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{ 'SYSTEM_SETTINGS.INTEGRATIONS.CONFIRM_STATE_CHANGE_TITLE' | translate }}
    </span>
  </ng-template>

  <ng-template pTemplate="message">
    <div class="flex flex-column align-items-center w-full gap-3">
      <p [innerHTML]="sanitizedConfirmMessage"></p>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button id="btn-cancel-integration-state-change" type="button" class="btn outline-btn" (click)="onCancelGraceInsuranceStateChange()">
      {{ 'MODALBOXES.BTN_CANCEL_STATE_UPDATE' | translate }}
    </button>

    <button id="btn-confirm-integration-state-change" type="button" class="btn primary-btn" (click)="onConfirmGraceInsuranceStateChange()">
      {{ 'MODALBOXES.BTN_CONFIRM_STATE_UPDATE' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>
